import { Alert, Button, DatePicker, Form, InputNumber, Radio, Spin } from 'antd';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import { FormComponentProps } from "antd/lib/form";
import { RadioChangeEvent } from 'antd/lib/radio';
import moment from 'moment';
import { EOL } from 'os';
import React, { FormEvent } from 'react';
import { getFinanceReport, IFinanceReport, IFinanceReportError } from 'src/apis/Reporting/ChargeHistory';

const FormItem = Form.Item;

interface ILocalState {
  companyProfileID: number|undefined,
  endDate: moment.Moment|undefined,
  error: IFinanceReportError|undefined,
  loading: boolean,
  reportData: IFinanceReport|IFinanceReportError|undefined,
  reportType: 'billing'|'payments',
  startDate: moment.Moment|undefined,
}

const { RangePicker } = DatePicker;

class ReportForm extends React.Component<FormComponentProps, ILocalState> {

  public constructor(props: FormComponentProps) {
    super(props);
    this.clearError = this.clearError.bind(this);
  }

  public componentWillMount() {
    this.setInitialState();
  }

  public handleDateRangeChange = (dates: RangePickerValue, dateStrings: string[]) => {
    if (dates.length === 0) {
      return;
    }

    this.setState({
      endDate: dates[1],
      startDate: dates[0],
    });

    return;
  }

  public handleCompanyProfileChange = (companyProfileID?: number) => {
    this.setState({
      companyProfileID,
    });
  }

  public handleReportTypeChange = (e: RadioChangeEvent) => {
    const reportType: string = e.target.value;
    if (reportType !== 'billing' && reportType !== 'payments') {
      return;
    }

    this.setState({
      reportType,
    });
  }

  public handleSubmit = (e: FormEvent) => {
    this.setState({
      loading: true,
    });
    e.preventDefault();
    this.props.form.validateFields((error, values) => {
      if (!error) {
        this.getReportData();
      }
    });
  }

  public render() {
    const { getFieldDecorator } = this.props.form;
    const today = moment();
    const thisYear = moment().year();
    const sevenDaysAgo = moment().subtract(7, 'd');
    const thirtyDaysAgo = moment().subtract(30, 'd');
    const ninetyDaysAgo = moment().subtract(90, 'd');

    return (
      <div>
        <div style={{position: 'relative', top: 0, left: 0, zIndex: 1}}>
          {this.state.error &&
            <Alert afterClose={this.clearError} closable={true} message='Error' description={this.state.error.message} showIcon={true} type='error' />
          }
          <Form layout='inline' id='financeReport' onSubmit={this.handleSubmit}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column'}}>
              <FormItem label='Report Type'>
                <Radio.Group defaultValue='billing' onChange={this.handleReportTypeChange}>
                  <Radio value='billing'>Billing</Radio>
                  <Radio value='payments'>Payments</Radio>
                </Radio.Group>
              </FormItem>
              <FormItem label='Date Range '>
                {getFieldDecorator('dateRange', {
                  initialValue: [moment(this.state.startDate), moment(this.state.endDate)],
                })(<RangePicker
                  onChange={this.handleDateRangeChange}
                  showTime={{}}
                  format='MM/DD/YYYY'
                  placeholder={['Start Date', 'End Date']}
                  ranges={{
                    'Last 07 Days,': [sevenDaysAgo, today],
                    'Last 30 Days,': [thirtyDaysAgo, today],
                    'Last 90 Days,': [ninetyDaysAgo, today],
                    'Q1 This Year,': [moment(`${thisYear}-01-01`, 'YYYY-MM-DD'), moment(`${thisYear}-03-31`, 'YYYY-MM-DD')],
                    'Q2 This Year,': [moment(`${thisYear}-04-01`, 'YYYY-MM-DD'), moment(`${thisYear}-06-30`, 'YYYY-MM-DD')],
                    'Q3 This Year,': [moment(`${thisYear}-07-01`, 'YYYY-MM-DD'), moment(`${thisYear}-09-30`, 'YYYY-MM-DD')],
                    'Q4 This Year': [moment(`${thisYear}-10-01`, 'YYYY-MM-DD'), moment(`${thisYear}-12-31`, 'YYYY-MM-DD')],
                  }}
                />)}
              </FormItem>
              <FormItem label='Company ID'>
                {getFieldDecorator('companyProfileID', {
                  initialValue: this.state.companyProfileID,
                  rules: [{ type: 'number', required: false, message: 'Company profile id can only contain numbers'}],
                })(<InputNumber style={{width: 200}} onChange={this.handleCompanyProfileChange} placeholder='Optional' />)}
              </FormItem>
              <FormItem>
                <Button size='small' type='primary' htmlType='submit'>
                  Generate Report
                </Button>
              </FormItem>
            </div>
          </Form>
        </div>
        {this.state.loading &&
            <div style={{ background: 'rgba(0, 0, 0, 0.6)', height: '100%', left: 0, position: 'absolute', top: 0, width: '100%', zIndex: 2 }}>
              <Spin style={{ alignItems: 'center', display: 'flex', height: '100%', justifyContent: 'center' }} />
          </div>
        }
      </div>

    );
  }

  private clearError() {
    if (this.state.error !== undefined) {
      if (this.state.error.code === 416 || (this.state.error.code === 404 && !this.state.error.message.includes('customer'))) {
        this.props.form.setFieldsValue({
          dateRange: [moment().subtract(7, 'd'), moment()],
        });

        this.setState({
          endDate: moment(),
          startDate: moment().subtract(7, 'd'),
        });
      }

      if (this.state.error.code === 404) {
        this.props.form.setFieldsValue({
          companyProfileID: undefined,
        });

        this.setState({
          companyProfileID: undefined
        });
      }

      this.setState({
        error: undefined,
        reportData: undefined,
      });
    }
  }

  private async getReportData() {
    if (this.state.startDate === undefined
      || this.state.endDate === undefined
      || (this.state.reportType !== 'billing' && this.state.reportType !== 'payments')
    ) {
      return;
    }

    try {
      const reportData = await getFinanceReport(
        this.state.reportType,
        this.state.startDate.format('YYYY-MM-DD'),
        this.state.endDate.format('YYYY-MM-DD'),
        this.state.companyProfileID,
      );

      this.setState({
        reportData,
      });

      this.exportCSV(reportData);
    } catch (error) {
      this.setState({
        error,
        loading: false,
      });
    }
  }

  private resetState() {
    this.props.form.setFieldsValue({
      companyProfileID: undefined,
      dateRange: [moment().subtract(7, 'd'), moment()],
    });
    this.setInitialState();
  }

  private setInitialState() {
    this.setState({
      companyProfileID: undefined,
      endDate: moment(),
      loading: false,
      reportData: undefined,
      reportType: 'billing',
      startDate: moment().subtract(7, 'd'),
    });
  }

  private exportCSV(reportData: IFinanceReport) {
    const csvContent =
      reportData.headers.join(',') +
      '\n' +
      reportData.rows.map((rowArray: Array<string | number>) => {
        return rowArray.map((field: string| number) => {
          if (typeof field === 'number') {
            field = field.toString();
          }

          if (field.search(/("|,|\n)/g) >= 0) {
            field = `"${field}"`;
          }
          return field;
        }).join(',');
      }).join('\n')
      + EOL;

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, reportData.title);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', reportData.title);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    this.resetState();
  }
}

export default Form.create()(ReportForm);
